import React, { Component } from 'react'
import styled from 'styled-components'
import { Card, StyledImage } from './'
import { XXLText, FlexWrapper } from './StyledComponents'

const CardWrap = styled.div`
  width: calc(50% - 5px);
  margin-top: 10px;
  & > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    // height: 166px;
    & > img {
      // height: 100%;
    }
  }
  position: relative;
`
const ImageWrap = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  & > img {
    max-width: 100%;
    height: 166px;
    width: 100%;
    object-fit: cover;
    border-radius: 0;
    margin: 0 auto;
    border-radius: 5px;
  }
`
class Category extends Component {
  render() {
    const { title, image, ...props } = this.props
    return (
      <React.Fragment>
        <CardWrap {...props}>
          <Card padding="0 0 0 0" boxShadow="0 3px 6px 0 rgba(0, 0, 0, 0.16)" boxRadius="5px" bgColor="#fff">
            <ImageWrap>
              <StyledImage src={image ? image : require('../static/images/bakery_and_bread@3x.png')} />
            </ImageWrap>
          </Card>
          <FlexWrapper
            viewPadding="10px"
            backgroundColor="rgba(255, 255, 255, 0.9)"
            style={{ position: 'absolute', bottom: 0, left: 0, zIndex: '99999', borderRadius: '0 0 5px 5px' }}>
            <XXLText fontWeight="600">{title}</XXLText>
          </FlexWrapper>
        </CardWrap>
      </React.Fragment>
    )
  }
}

export default Category



// WEBPACK FOOTER //
// ./src/components/Category.js